export default {
  access_token: null,
  refresh_token: null,
  isLoading: false,
  redirect: ''
}



// WEBPACK FOOTER //
// ./src/features/Auth/store/state.js